window._ = require('lodash');

/**
 * We'll load jQuery and the Bootstrap jQuery plugin which provides support
 * for JavaScript based Bootstrap features such as modals and tabs. This
 * code may be modified to fit the specific needs of your application.
 */

window.$ = window.jQuery = require('jquery');
window.Popper = require('popper.js').default;
window.offsetPolygon = require('offset-polygon').default;

require('bootstrap');

/**
 * Vue is a modern JavaScript library for building interactive web interfaces
 * using reactive data binding and reusable components. Vue's API is clean
 * and simple, leaving you to focus on building your next great project.
 */

// window.Vue = require('vue');

import Echo from 'laravel-echo'
/**
 * Translations coupling from server to client.
 */

import Pusher from 'pusher-js';

window.Pusher = Pusher;

function startLaravelEcho() {
    if (window.LaravelEcho) {
        return window.LaravelEcho;
    }

    if (getState() === false) {
        console.error(`Unable to start Laravel Echo outside of map context!`);
        return null;
    }

    window.LaravelEcho = new Echo({
        broadcaster: 'reverb',
        key: getState().getLaravelEchoAppKey(),
        wsHost: window.location.hostname,
        wsPort: window.location.protocol === 'https:' ? null : (window.location.port ?? 80),
        wssPort: 443,
        forceTLS: window.location.protocol === 'https:',
        wsPath: '/reverb',
        enabledTransports: ['ws', 'wss'],
        // disableStats: true,
        // cluster: 'mt1', // Required by pusher-js, even if unused by Reverb
    });

    return window.LaravelEcho;
}

function stopLaravelEcho() {
    if (!window.LaravelEcho) return;
    try {
        window.LaravelEcho.disconnect();
    } catch (e) {
    }
    window.LaravelEcho = null;
    delete window.LaravelEcho;
}

window.startLaravelEcho = startLaravelEcho;
window.stopLaravelEcho = stopLaravelEcho;

/**
 * We'll load the axios HTTP library which allows us to easily issue requests
 * to our Laravel back-end. This library automatically handles sending the
 * CSRF token as a header based on the value of the "XSRF" token cookie.
 */

window.axios = require('axios');

window.datatables = require('datatables.net');
window.leaflet = require('leaflet');
window.leafletdraw = require('leaflet-draw');
// window.leafleteditable = require('leaflet-editable');
window.leafletcontextmenu = require('leaflet-contextmenu');
window.edgeBuffer = require('leaflet-edgebuffer');
window.GestureHandling = require('leaflet-gesture-handling');
// window.interpolate = require('color-interpolate');
window.gju = require('geojson-utils');
window.bootstrapselect = require('bootstrap-select');
window.Handlebars = require('handlebars');
window.barrating = require('jquery-bar-rating');
window.polylinedecorator = require('leaflet-polylinedecorator');
window.lightCarousel = require('lightslider');
window.introjs = require('intro.js');
window.pwstrengthmeter = require('password-strength-meter');
window.jqueryMousewheel = require('jquery-mousewheel');
window.Cookies = require('js-cookie');
window.hull = require('hull.js'); // Find the 'hull' of a random set of points
const offsetPolygon = require("offset-polygon");
window.Lang = require('lang.js'); // Javascript translations
window.d3 = require('d3'); // v3.5.14 since Pather uses an out-of-date version
window.Pather = require('leaflet-pather');
// window.circleMenu = require('zikes-circlemenu');
window.Noty = require('noty');
window.Pickr = require('@simonwep/pickr');
window.AntPath = require('leaflet-ant-path');
window.Grapick = require('grapick');
window.jqueryVisible = require('jquery-visible');
window.simplebar = require('simplebar');
window.Draggable = require('@shopify/draggable');
window.autocomplete = require('bootstrap-4-autocomplete');
window.toggle = require('bootstrap4-toggle');
window.swipe = require('jquery-touchswipe');
window.lazysizes = require('lazysizes');
window.ionRangeSlider = require('ion-rangeslider');

require('@fortawesome/fontawesome-free');

window.axios.defaults.headers.common = {
    'X-Requested-With': 'XMLHttpRequest'
};
// Initialize with empty messages; language bundles (public/js/lang-<locale>-<version>.js)
// will populate messages at runtime via window.lang.setMessages(...)
window.lang = new Lang({messages: {}});

// https://stackoverflow.com/questions/13046401/how-to-set-selected-select-option-in-handlebars-template
window.Handlebars.registerHelper('select', function (value, options) {
    var $el = $('<select />').html(options.fn(this));
    $el.find('[value="' + value + '"]').attr({'selected': 'selected'});
    return $el.html();
});

// https://stackoverflow.com/questions/8853396/logical-operator-in-a-handlebars-js-if-conditional
window.Handlebars.registerHelper('ifCond', function (v1, operator, v2, options) {
    switch (operator) {
        case '==':
            return (v1 == v2) ? options.fn(this) : options.inverse(this);
        case '===':
            return (v1 === v2) ? options.fn(this) : options.inverse(this);
        case '!=':
            return (v1 != v2) ? options.fn(this) : options.inverse(this);
        case '!==':
            return (v1 !== v2) ? options.fn(this) : options.inverse(this);
        case '<':
            return (v1 < v2) ? options.fn(this) : options.inverse(this);
        case '<=':
            return (v1 <= v2) ? options.fn(this) : options.inverse(this);
        case '>':
            return (v1 > v2) ? options.fn(this) : options.inverse(this);
        case '>=':
            return (v1 >= v2) ? options.fn(this) : options.inverse(this);
        case '&&':
            return (v1 && v2) ? options.fn(this) : options.inverse(this);
        case '||':
            return (v1 || v2) ? options.fn(this) : options.inverse(this);
        default:
            return options.inverse(this);
    }
});
